import React, { ElementType } from 'react';

import { VariantProps, cva } from 'class-variance-authority';

import { cn } from '../lib';

const headingVariants = cva(
  'font-right-grotesk text-center uppercase [pointer-events:all]',
  {
    variants: {
      variant: {
        xxl: 'text-[92px] leading-[80px] -tracking-[0.92px]',
        kyb: 'text-[72px] leading-[70px] -tracking-[0.72px]',
        xl: 'text-[52px] leading-[50px] -tracking-[0.52px]',
        l: 'text-[48px] leading-[46px] -tracking-[0.48px]',
        m: 'text-[40px] leading-[38px] -tracking-[0.4px]',
        s: 'text-[36px] leading-[34px] -tracking-[0.36px]',
        xs: 'text-[26px] leading-[32px]',
      },
      color: {
        default: 'text-base-500',
        'base-100': 'text-base-100',
      },
    },

    defaultVariants: {
      variant: 'xl',
      color: 'default',
    },
  },
);

type TagType = 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6' | 'span' | 'p';
export type HeadingVariant = VariantProps<typeof headingVariants>['variant'];
interface IHeadingProps
  extends Omit<React.HTMLAttributes<HTMLElement>, 'color'>,
    VariantProps<typeof headingVariants> {
  tag?: TagType;
}

export const Heading = ({
  children,
  className,
  variant,
  tag = 'h1',
  color,
  ...props
}: IHeadingProps) => {
  const Tag = tag as ElementType;
  return (
    <Tag
      className={cn(headingVariants({ variant, color, className }))}
      {...props}
    >
      {children}
    </Tag>
  );
};
